import type { AgentLessonContent } from "./lessonSnapshot";
import type { LessonContextInput } from "@components/agent/types";

export function mergeLessonContextInput(
  current: LessonContextInput | null,
  pendingContent: AgentLessonContent | null,
  incoming: LessonContextInput,
): { ctx: LessonContextInput; pendingContent: AgentLessonContent | null } {
  let content: AgentLessonContent | null | undefined;
  let nextPending = pendingContent;

  if (incoming.content !== undefined) {
    content = incoming.content;
    nextPending = null;
  } else if (pendingContent) {
    content = pendingContent;
    nextPending = null;
  } else {
    content = current?.content ?? null;
  }

  return {
    ctx: {
      lesson: incoming.lesson,
      content,
      phase: incoming.phase ?? current?.phase,
      targetLocale: incoming.targetLocale ?? current?.targetLocale,
      nativeLocale: incoming.nativeLocale ?? current?.nativeLocale,
    },
    pendingContent: nextPending,
  };
}

export function applyLessonContentPatch(
  current: LessonContextInput | null,
  pendingContent: AgentLessonContent | null,
  content: AgentLessonContent,
): { ctx: LessonContextInput | null; pendingContent: AgentLessonContent | null } {
  if (current) {
    return {
      ctx: { ...current, content },
      pendingContent: null,
    };
  }

  return {
    ctx: null,
    pendingContent: content,
  };
}
